import { render, staticRenderFns } from "./ZonePresidentAssign.vue?vue&type=template&id=1e15be35"
import script from "./ZonePresidentAssign.vue?vue&type=script&lang=js"
export * from "./ZonePresidentAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports